<template>
  <CodSheet v-model="isOpen" width="480px">
    <div class="p-5">
      <UAlert :color="color" variant="solid">
        <template #title>
          <!-- Invoice Generated Notification -->
          <span v-if="notification?.code === 'invoice_generated'">
            {{ t('notification.invoice_generated_heading', { month: getMonth(notification?.data?.month || '') }) }}
          </span>

          <span v-else-if="notification?.code">{{ t(`notification.${notification.code}_heading`) }}</span>
          <span v-else>{{ t('notification.heading') }}</span>
        </template>

        <template #description>
          <!-- Invoice Generated Notification -->
          <template v-if="notification?.code === 'invoice_generated'">
            <span>
              {{
                t('notification.invoice_generated', {
                  software: 'Konty',
                  amount: Money.parse(notification?.data?.amount || 0).toFormat(),
                  month: getMonth(notification?.data?.month || '')
                })
              }}
            </span>
            <div class="mt-2">{{ t('notification.invoice_generated_check') }}</div>
          </template>

          <template v-else-if="notification?.code">
            {{ t(`notification.${notification.code}`) }}
          </template>

          <span v-else>
            {{ notification?.text }}
          </span>
        </template>
      </UAlert>
    </div>

    <template #footer>
      <UButton size="lg"
        color="neutral"
        variant="outline"
        :label="t('general.close')"
        @click="hide"
      />
    </template>
  </CodSheet>
</template>

<script setup lang="ts">
import { Ref, inject, onMounted, onUnmounted, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { useAppStore } from '@/stores/useAppStore'
import { Emitter } from '@/utilities/emitter';
import { Notification } from 'app-core';
import { Money } from 'app-core';
import { CodSheet } from 'app-components';
import moment from 'moment-timezone'

const { t } = useI18n()
const store = useAppStore()
const emitter = inject('emitter') as Emitter

const isOpen = ref(false)
const notification: Ref<Notification | null> = ref(null)
const color = computed<'warning' | 'success' | 'error' | 'primary'>(() => {
  if(notification.value?.type === 'warning') return 'warning'
  if(notification.value?.type === 'success') return 'success'
  if(notification.value?.type === 'error') return 'error'

  return 'primary'
})

onMounted(() => {
  emitter.on('showNotification', showNotification)
})

onUnmounted(() => {
  emitter.off('showNotification', showNotification)
})

function showNotification(data: Notification) {
  notification.value = data
  isOpen.value = true
}

function hide() {
  markAsSeen()
  notification.value = null
  isOpen.value = false;
}

function markAsSeen() {
  if(store.impersonate) return
  notification.value?.markAsRead()
}

function getMonth(month: string) {
  if(!month) return ''

  return t(`months.${moment(month, 'MM/YYYY').format('MMMM').toLowerCase()}`) +
    ` ${moment(month, 'MM/YYYY').format('YYYY')}.`
}

</script>
